import { Uuid } from "@/domains/global/identifiers";
import { api } from "@/modules/api";
import { useQuery } from "@tanstack/react-query";
import { FC } from "react";
import { useNavigate, useParams } from "react-router";
import { Button, Flex } from "@radix-ui/themes";
import Lowlight from "react-lowlight";
import styled from "@emotion/styled";
import { atlasRoutes } from "@/app/router/routes";

export const AppEventsViewPage: FC = () => {
  const navigate = useNavigate();
  const { appEventId } = useParams<{ appEventId: Uuid }>();

  if (!appEventId) return <div>Invalid ID</div>;

  const result = useQuery({
    queryKey: ["app-event-by-id", appEventId],
    queryFn: () =>
      api.get("/internal/v1/app-events/{app_event_id}", {
        params: { path: { app_event_id: appEventId } },
      }),
    staleTime: 60 * 1000,
  });

  const handleViewSpaceAccount = () => {
    const spaceAccountId = result.data?.data?.associated_space_account_id;
    if (!spaceAccountId) return alert("No associated space account.");
    navigate(atlasRoutes.spaceAccountsView({ params: { spaceAccountId } }).path);
  };

  if (result.isLoading) return <div>Loading...</div>;
  if (result.isError || !result.data) return <div>Error: {result.error?.message}</div>;

  return (
    <Container>
      <ButtonGroup>
        <Button variant="soft" onClick={handleViewSpaceAccount}>
          View Space Account
        </Button>
      </ButtonGroup>
      <h1>App Event</h1>
      <Lowlight language="json" value={JSON.stringify(result.data, null, 2)} markers={[]} />
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  padding: 20px;
`;

const ButtonGroup = styled(Flex)`
  gap: 12px;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 12px;
`;
